import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddCombinationComponent } from '../add-combination/add-combination.component';
import { AddPipeSpecComponent } from '../add-pipe-spec/add-pipe-spec.component';
import { userActions } from 'src/app/models/enums/user-permissions.enum';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { IdmApiService } from 'src/app/services';
import { PipeSpecificationCodes, PipeSpecs, pipeSpecVersion } from 'src/app/Modules/settings/models/idms/pipe-specification.model';
import { FormArray, FormGroup, UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { AddPipeCodes, AddPipeSpecVersion, UpdatePipeCodeSpecification, UpdatePipespec } from 'src/app/Modules/settings/models/idms/add-pipe-codes.model';
import { Subject } from 'rxjs';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { takeUntil } from 'rxjs/operators';
import { CalculationOverridesInput, GeneralInput, RecordIdInput } from 'src/app/Modules/informate/models';
import { AddPipeSpec } from 'src/app/Modules/settings/models/idms/add-pipe-codes.model';
import { CustomToastService } from 'src/app/services/custom-toast.service';
import { DeleteDialogComponent } from 'src/app/shared/info-dialogs/delete-dialog/delete-dialog.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { UniqueNameValidation } from 'src/app/Modules/management/core/Validators/unique-name.validator';
import { SuccessDialogComponent } from 'src/app/shared/info-dialogs/success-dialog/success-dialog.component';
import { UploadApiService } from 'src/app/services/uploadapi.service';
import { IdmsSharedService } from 'src/app/Modules/idms/services/idms-shared.service';
import { WarningConfirmationDialogComponent } from 'src/app/shared/info-dialogs/warning-confirmation-dialog/warning-confirmation-dialog.component';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-pipe-codes',
    templateUrl: './pipe-codes.component.html',
    styleUrls: ['./pipe-codes.component.scss'],
})
export class PipeCodesComponent implements OnInit, OnDestroy {
    @Input() idmsFormGroup: UntypedFormGroup;
    destory$: Subject<any>;

    tooltip_position = 'above';
    public configure: boolean = false;
    public EditPipeCodes: boolean;
    createPipeCodes: boolean;
    deletePipeCodes: boolean;
    isActive: boolean = false;
    pipeCodes: PipeSpecificationCodes[] = [];
    pipeCodesCopy: PipeSpecificationCodes[] = [];
    pipeSpecs: PipeSpecificationCodes;
    selectedPipeCode!: PipeSpecificationCodes;
    selectedTabIndex: number;
    standardFlangeForm: UntypedFormGroup;
    tighteningSpecification: UntypedFormGroup;
    processInformation: UntypedFormGroup;
    clampForm: UntypedFormGroup;
    calculationType: number;
    selectedPipeSpec: PipeSpecs;
    pipeCodeNameList: string[];
    stateOptions: any = [
        { label: 'mm', value: 0 },
        { label: 'in', value: 1 },
    ];

    ids: String[] = [];
    constructor(
        private modelService: NgbModal,
        private user_utility: UserUtilityService,
        private idmapiService: IdmApiService,
        private cd: ChangeDetectorRef,
        private globalEmittersService: GlobalEmittersService,
        private toastrService: CustomToastService,
        private ngxUiLoaderService: NgxUiLoaderService,
        private uploadApiService: UploadApiService,
        private transLocoService: TranslocoService
    ) {
        this.selectedTabIndex = 0;
        this.destory$ = new Subject();
    }

    async ngOnInit(): Promise<void> {
        //checking user has permission to edit pipecodes
        this.EditPipeCodes = await this.user_utility.checkUserPermissionDataAndRoute('settings-iDMS-pipeCodes', userActions.Edit);
        this.createPipeCodes = await this.user_utility.checkUserPermissionDataAndRoute('settings-iDMS-pipeCodes', userActions.Create);
        this.deletePipeCodes = await this.user_utility.checkUserPermissionDataAndRoute('settings-iDMS-pipeCodes', userActions.Delete);
        await this.getpipeSpec();
        this.getintilizeform();
    }

    getintilizeform() {
        this.globalEmittersService.pipeCodesSaveEvent.pipe(takeUntil(this.destory$)).subscribe((res) => {
            if (res == true) {
                this.savePipeSpecs();
            }
        });

        this.globalEmittersService.standardInputForm.pipe(takeUntil(this.destory$)).subscribe((form: UntypedFormGroup) => {
            if (form) {
                this.standardFlangeForm = form;
                this.formControlHandler(2, null, null, null);
            }
        });
        this.globalEmittersService.clampInputFormGroup.pipe(takeUntil(this.destory$)).subscribe((form) => {
            if (form) {
                this.clampForm = form;
                this.clampForm.patchValue(form.value);
                this.formControlHandler(5, null, null, null);
            }
        });
        this.globalEmittersService.tighteningProcedureForm.pipe(takeUntil(this.destory$)).subscribe((form) => {
            if (form) {
                this.tighteningSpecification = form;
                this.formControlHandler(3, null, null, null);
            }
        });

        this.globalEmittersService.processInfoForm.pipe(takeUntil(this.destory$)).subscribe((form) => {
            if (form) {
                this.processInformation = form;
                this.formControlHandler(8, null, null, null);
            }
        });
    }

    getFilteredStateOptions(pipe) {
        // console.log(this.stateOptions.filter((option) => option.value === pipe.pipeSizeType));
        return this.stateOptions.filter((option) => option.value === pipe.pipeSizeType);
    }

    async initfomGroup() {
        const mainFormGroup = (value: PipeSpecificationCodes) => {
            return new UntypedFormGroup({
                pipeCodeId: new UntypedFormControl(value?.pipeCodeId, []),
                name: new UntypedFormControl(value?.name, [Validators.required]),
                description: new UntypedFormControl(value?.description),
                pipeSizeType: new UntypedFormControl(value.pipeSizeType),
                isCheck: new UntypedFormControl(false),
                pipeSpecs: new UntypedFormArray([]),
            });
        };

        const pipeSpecFormGroup = (pipeSpec: PipeSpecs) => {
            return new UntypedFormGroup({
                pipeSpecId: new UntypedFormControl(pipeSpec?.pipeSpecId, []),
                name: new UntypedFormControl(pipeSpec?.name),
                versions: new UntypedFormArray([]),
            });
        };

        const versionFormGroup = (version: pipeSpecVersion) => {
            if (version.calculationType == 0) {
                return this.formControlHandler(1, version, null, null);
            } else if (version.calculationType == 2) {
                return this.formControlHandler(7, version, null, null);
            }
        };
        // let pipeCodeFormArray:FormArray;

        let pipeCodeFormArray = this.idmsFormGroup.get('pipeCodes') as UntypedFormArray;
        this.pipeCodes.forEach((pipeCode, index) => {
            // Pipecode main form group
            pipeCodeFormArray.push(mainFormGroup(pipeCode));
            const pipeSpecArray = pipeCodeFormArray.controls[index].get('pipeSpecs') as UntypedFormArray;

            // Pipe spec form group
            if (pipeCode?.pipeSpecs?.length) {
                pipeCode.pipeSpecs.forEach((pipeSpec, pos) => {
                    pipeSpecArray.push(pipeSpecFormGroup(pipeSpec));
                    const versionFormArray = pipeSpecArray.controls[pos].get('versions') as UntypedFormArray;
                    if (pipeSpec.versions?.length) {
                        pipeSpec.versions.forEach((version) => {
                            versionFormArray.push(versionFormGroup(version));
                        });
                    }
                });
            }
        });
    }

    // * helper method to add new combination
    addCombination(): void {
        let dialogref = this.modelService.open(AddCombinationComponent);
        dialogref.componentInstance.selectedPipeCode = this.selectedPipeCode;
        dialogref.componentInstance.tittle = this.transLocoService.translate('SETTING_PAGE.IDMS_SETTINGS.ADD_PIPESPEC_COMBINATION');
        dialogref.componentInstance.mode = 'Add';
        dialogref.result
            .then((result: any) => {
                if (result) {
                    let pipeSpecindex = -1;
                    if (this.selectedPipeCode?.pipeSpecs?.length > 0) {
                        pipeSpecindex = this.selectedPipeCode.pipeSpecs.findIndex((x) => x.name == result.CombinationName);
                    } else {
                        this.selectedPipeCode.pipeSpecs = [];
                    }
                    if (pipeSpecindex == -1) {
                        let obj = new PipeSpecs();
                        obj.name = result.CombinationName;
                        this.calculationType = result.CalculationType;
                        obj.versions = [];
                        this.selectedPipeCode.pipeSpecs.push(obj);
                        this.selectedTabIndex = this.selectedPipeCode.pipeSpecs.length > 0 ? this.selectedPipeCode.pipeSpecs.length - 1 : 0;
                        this.pipeSpecs = this.selectedPipeCode;
                        this.configure = true;
                        this.isActive = true;
                        this.selectedPipeSpec = obj;
                        this.cd.detectChanges();
                        this.cd.markForCheck();

                        let pipeCodeFormArray = this.idmsFormGroup.get('pipeCodes') as UntypedFormArray;
                        const pipeCodeControlIndex = pipeCodeFormArray.controls.findIndex(
                            (pipeControl) => this.selectedPipeCode.name.toLowerCase().trim() == pipeControl.value.name.toLowerCase().trim()
                        );

                        if (pipeCodeControlIndex !== -1) {
                            let pipeSpecFromArray = pipeCodeFormArray.controls[pipeCodeControlIndex].get('pipeSpecs') as UntypedFormArray;
                            pipeSpecFromArray.push(this.formControlHandler(4, null, obj, null));
                            this.cd.detectChanges();
                        }

                        this.addNewVersions();
                    } else {
                        this.toastrService.warningToast('Pipespec name already exists!');
                    }
                }
                // this.getintilizeform();
            })
            .catch((err) => {
                console.warn(err);
            });
    }

    // * helper method to add new pipe Specs
    addpipeCodes(): void {
        let dialogref = this.modelService.open(AddPipeSpecComponent);
        dialogref.componentInstance.tittle = this.transLocoService.translate('SETTING_PAGE.IDMS_SETTINGS.ADD_PIPE_SPEC');

        dialogref.componentInstance.mode = 'Add';
        dialogref.result
            .then((result: any) => {
                if (result) {
                    let pipeCodeIndex = this.pipeCodes.findIndex((x) => x.name == result.name);
                    if (pipeCodeIndex == -1) {
                        const newPipeCode = new PipeSpecificationCodes();
                        newPipeCode.name = result.name;
                        newPipeCode.description = result.discription;
                        newPipeCode.pipeSizeType = result.pipeSizeType;
                        newPipeCode.pipeSpecs = [];

                        let pipeCodeFormArray = this.idmsFormGroup.get('pipeCodes') as UntypedFormArray;
                        // pipeCodeFormArray.push(this.formControlHandler(6, null, null, newPipeCode));
                        let newControl = this.formControlHandler(6, null, null, newPipeCode);
                        newControl.markAsDirty();
                        newControl.get('name').markAsDirty();
                        newControl.get('description').markAsDirty();
                        pipeCodeFormArray.push(newControl);
                        this.cd.markForCheck();
                        this.pipeCodes.push(newPipeCode);

                        this.selectedPipeCode = newPipeCode;
                        this.selectedTabIndex = 0;
                        this.pipeSpecs = newPipeCode;
                        pipeCodeFormArray.markAsDirty();
                    } else {
                        this.toastrService.errorToast('pipeCode name already exists!');
                    }
                }
            })
            .catch((error) => {
                console.warn(error);
            });
    }

    // * helper method to add new version
    addNewVersions(): void {
        let pipeCodeFormArray = this.idmsFormGroup.get('pipeCodes') as UntypedFormArray;
        const pipeCodeControlIndex = pipeCodeFormArray.controls.findIndex(
            (pipeControl) => this.selectedPipeCode.name.toLowerCase().trim() == pipeControl.value.name.toLowerCase().trim()
        );
        if (pipeCodeControlIndex !== -1) {
            const pipeSpecFromArray = pipeCodeFormArray.controls[pipeCodeControlIndex].get('pipeSpecs') as UntypedFormArray;
            const versionForm = pipeSpecFromArray.controls[this.selectedTabIndex].get('versions') as UntypedFormArray;
            // versionForm.
            if (this.calculationType >= 0) {
                if (this.calculationType == 0) {
                    versionForm.push(this.formControlHandler(1, null, null, null));
                } else {
                    versionForm.push(this.formControlHandler(7, null, null, null));
                }
            } else if (this.selectedPipeCode.pipeSpecs[this.selectedTabIndex].versions[versionForm.controls.length - 1]?.calculationType == 0) {
                versionForm.push(
                    this.formControlHandler(1, this.selectedPipeCode.pipeSpecs[this.selectedTabIndex].versions[versionForm.controls.length - 1], null, null)
                );
            } else if (this.selectedPipeCode.pipeSpecs[this.selectedTabIndex].versions[versionForm.controls.length - 1]?.calculationType == 2) {
                versionForm.push(
                    this.formControlHandler(7, this.selectedPipeCode.pipeSpecs[this.selectedTabIndex].versions[versionForm.controls.length - 1], null, null)
                );
            }

            let lastVersionIndex = this.selectedPipeCode.pipeSpecs[this.selectedTabIndex].versions.length - 1;
            if (lastVersionIndex == -1) {
                versionForm.controls[versionForm.controls.length - 1].markAsDirty();

                let newPiepSpecVersion = new pipeSpecVersion();
                newPiepSpecVersion.version = 1;
                newPiepSpecVersion.calculationType = this.calculationType;
                newPiepSpecVersion.recordId = new RecordIdInput();
                newPiepSpecVersion.minimumPipeSizeId = '';
                newPiepSpecVersion.maximumPipeSizeId = '';
                newPiepSpecVersion.pipeSizeType = this.selectedPipeCode.pipeSizeType;
                newPiepSpecVersion.others = new GeneralInput();
                newPiepSpecVersion.calculationOverrides = new CalculationOverridesInput();
                this.selectedPipeCode.pipeSpecs[this.selectedTabIndex].versions.push(newPiepSpecVersion);
            } else {
                versionForm.controls[0].reset(versionForm.controls[versionForm.controls.length - 2].value);

                versionForm.controls[versionForm.controls.length - 1].markAsDirty();
                let newPiepSpecVersion = JSON.parse(JSON.stringify(this.selectedPipeCode.pipeSpecs[this.selectedTabIndex].versions[0]));
                newPiepSpecVersion.version = newPiepSpecVersion.version + 1;
                delete newPiepSpecVersion.pipeSpecVersionId;
                this.selectedPipeCode.pipeSpecs[this.selectedTabIndex].versions.push(newPiepSpecVersion);
            }
            this.selectedPipeCode.pipeSpecs[this.selectedTabIndex].versions?.sort((a, b) => b.version - a.version);
        }
    }

    async clickActive(pipe) {
        this.selectedTabIndex = 0;
        this.configure = true;
        this.isActive = true;
        this.selectedPipeCode = pipe;
        this.pipeSpecs = this.pipeCodes.find((x) => x.pipeCodeId == pipe.pipeCodeId);
        this.pipeSpecs?.pipeSpecs?.length ? (this.selectedPipeSpec = this.pipeSpecs?.pipeSpecs[0]) : (this.selectedPipeCode.pipeSpecs = []);
    }

    async getpipeSpec(name?: string) {
        try {
            let instanceId = localStorage.getItem('currentInstanceId');
            this.ngxUiLoaderService.start();
            let res = await this.idmapiService.getpipeSpecByInstanceId(instanceId).toPromise();

            if (res.success) {
                this.pipeCodes = res.response;
                this.pipeCodesCopy = res.response;
                this.pipeCodeNameList = [];
                if (name) {
                    this.selectedPipeCode = this.pipeCodes.find((m) => m.name == name);
                    if (this.selectedPipeCode) {
                        this.pipeSpecs = this.selectedPipeCode;
                        this.selectedPipeCode = this.selectedPipeCode;
                        // this.clickActive(this.selectedPipeCode);
                        this.configure = true;
                    } else {
                        this.configure = false;
                    }
                }

                await this.initfomGroup();
                this.cd.detectChanges();
                this.ngxUiLoaderService.stop();
            } else {
                this.ngxUiLoaderService.stop();
                this.user_utility.errorModelPopup(res.message);
            }
        } catch (err) {
            this.ngxUiLoaderService.stop();
        }
    }

    ClampFormhandler(event): void {
        this.clampForm = event;
        this.formControlHandler(5, null, null, null);
    }

    formControlHandler(index: number, version?: pipeSpecVersion, pipeSpec?: PipeSpecs, pipeCodes?: PipeSpecificationCodes) {
        /**
         * case ---- operation
         * 1 ---> generate new version form
         * 2 ---> subscribe stdFlange form
         * 3 ---> Subscribe tighten form
         * 4 ---> generate new pipe spec  form
         * 5 ---> Subscribe clamp form
         * 6 ---> generate new pipe coe  form
         * 7 ---> generate new clamp  form
         * 8 ---> Subscribe process information  form
         *
         */
        const recordId = version?.recordId;
        const others = version?.others;
        const calculationOverrides = version?.calculationOverrides;
        switch (index) {
            case 1:
                return new UntypedFormGroup({
                    calculationType: new UntypedFormControl(version?.calculationType, [Validators.required]),
                    minimumPipeSizeId: new UntypedFormControl(version?.minimumPipeSizeId, [Validators.required]),
                    maximumPipeSizeId: new UntypedFormControl(version?.maximumPipeSizeId, [Validators.required]),
                    pipeSizeType: new UntypedFormControl(
                        this.selectedPipeCode?.pipeSizeType !== null && this.selectedPipeCode?.pipeSizeType !== undefined
                            ? this.selectedPipeCode?.pipeSizeType
                            : version?.maximumPipeSizeId
                    ),

                    boltType: new UntypedFormControl(others?.boltType, [Validators.required]),

                    jointConfiguration: new UntypedFormControl(others?.jointConfiguration, []),

                    tighteningSpecification: new UntypedFormControl(others?.tighteningSpecification, [Validators.required]),
                    washerThickness: new UntypedFormControl('', []), //panding
                    boltMaterialId: new UntypedFormControl(recordId?.boltMaterialId, [Validators.required]),
                    boltMaterialAliasId: new UntypedFormControl('', []), //panding
                    flangeMaterialId: new UntypedFormControl(recordId?.flangeMaterialId, [Validators.required]),
                    flangeFacingTypeId: new UntypedFormControl(recordId?.flangeFacingTypeId),
                    flangeMaterialAliasId1: new UntypedFormControl('', []), //panding
                    flangeTypeId: new UntypedFormControl(recordId?.flangeTypeId, []),
                    gasketId: new UntypedFormControl(recordId?.gasketId, []),
                    gasketAliasId: new UntypedFormControl('', []), // panding

                    pipeScheduleId: new UntypedFormControl(recordId?.pipeScheduleId, [Validators.required]),
                    pressureClassId: new UntypedFormControl(recordId?.pressureClassId, [Validators.required]),
                    standardId: new UntypedFormControl(recordId?.standardId, [Validators.required]),

                    lubricantId: new UntypedFormControl(recordId?.lubricantId, [Validators.required]),
                    tighteningMethod: new UntypedFormControl(others?.tighteningMethod, [Validators.required]),
                    breakout: new UntypedFormControl(others?.breakout, []),
                    lubricantMode: new UntypedFormControl(others?.lubricantMode, []),
                    kFactor: new UntypedFormControl(calculationOverrides?.kFactor, []),
                    percentageCover: new UntypedFormControl(others?.percentageCover, []),

                    operatingPressure: new UntypedFormControl(calculationOverrides?.operatingPressure, []),
                    operatingTemperature: new UntypedFormControl(calculationOverrides?.operatingTemperature, []),
                    testPressure: new UntypedFormControl(calculationOverrides?.testPressure, []),
                });

            case 2:
                this.standardFlangeForm?.valueChanges.pipe(takeUntil(this.destory$)).subscribe((res) => {
                    if (res) {
                        this.setValuesOnFormControl(res, 1);
                    }
                });
                break;

            case 3:
                this.tighteningSpecification?.valueChanges.pipe(takeUntil(this.destory$)).subscribe((res) => {
                    if (res) {
                        this.setValuesOnFormControl(res, 2);
                    }
                });
                break;
            //adding pipespecs
            case 4:
                return new UntypedFormGroup({
                    name: new UntypedFormControl(pipeSpec?.name, [Validators.required]),
                    description: new UntypedFormControl(pipeSpec?.description, []),
                    pipeSpecId: new UntypedFormControl(pipeSpec?.pipeSpecId, []),
                    versions: new UntypedFormArray([]),
                });

            case 5:
                this.clampForm?.valueChanges.subscribe((res) => {
                    if (res) {
                        this.setValuesOnFormControl(res, 4);
                    }
                });
                break;
            //for adding pipe codes
            case 6:
                return new UntypedFormGroup({
                    name: new UntypedFormControl(pipeCodes?.name, [Validators.required]),
                    description: new UntypedFormControl(pipeCodes?.description, []),
                    pipeCodeId: new UntypedFormControl(pipeCodes?.pipeCodeId, []),
                    pipeSizeType: new UntypedFormControl(pipeCodes?.pipeSizeType, []),
                    pipeSpecs: new UntypedFormArray([]),
                });

            case 7:
                return new UntypedFormGroup({
                    calculationType: new UntypedFormControl(version?.calculationType ?? '', [Validators.required]),
                    minimumPipeSizeId: new UntypedFormControl(version?.minimumPipeSizeId, [Validators.required]),
                    maximumPipeSizeId: new UntypedFormControl(version?.maximumPipeSizeId, [Validators.required]),
                    pipeSizeType: new UntypedFormControl(
                        this.selectedPipeCode?.pipeSizeType !== null && this.selectedPipeCode?.pipeSizeType !== undefined
                            ? this.selectedPipeCode?.pipeSizeType
                            : version?.maximumPipeSizeId
                    ),
                    boltType: new UntypedFormControl(others?.boltType, [Validators.required]),

                    boltMaterialId: new UntypedFormControl(recordId?.boltMaterialId, [Validators.required]),
                    pipeScheduleId: new UntypedFormControl(recordId?.pipeScheduleId, []),

                    manufacturerId: new UntypedFormControl(recordId?.manufacturerId ?? '', [Validators.required]),
                    misalignmentFactor: new UntypedFormControl('', []), //panding
                    clampMaterialId: new UntypedFormControl(recordId?.clampMaterialId ?? '', [Validators.required]),
                    hubMaterialId: new UntypedFormControl(recordId?.hubMaterialId ?? '', [Validators.required]),
                    sealRingMaterialId: new UntypedFormControl(recordId?.sealRingMaterialId ?? '', []),
                    sealRingId: new UntypedFormControl(recordId?.sealRingId ?? '', []),
                    lubricantId: new UntypedFormControl(recordId?.lubricantId ?? '', [Validators.required]),
                    tighteningMethod: new UntypedFormControl(others?.tighteningMethod ?? '', [Validators.required]),
                    breakout: new UntypedFormControl(others?.breakout ?? '', []),
                    lubricantMode: new UntypedFormControl(others?.lubricantMode ?? '', []),
                    kFactor: new UntypedFormControl(calculationOverrides?.kFactor ?? '', []),
                    percentageCover: new UntypedFormControl(others?.percentageCover ?? '', []),
                });

            case 8:
                this.processInformation?.valueChanges.pipe(takeUntil(this.destory$)).subscribe((res) => {
                    if (res) {
                        this.setValuesOnFormControl(res, 3);
                    }
                });
                break;
        }
    }

    setValuesOnFormControl(res: any, index: number): void {
        let pipeCodeFormArray = this.idmsFormGroup.get('pipeCodes') as UntypedFormArray;
        const pipeCodeControlIndex = pipeCodeFormArray.controls.findIndex(
            (pipeControl) => this.selectedPipeCode.name.toLowerCase().trim() == pipeControl.value.name.toLowerCase().trim()
        );
        if (pipeCodeControlIndex !== -1) {
            const pipeSpecFromArray = pipeCodeFormArray.controls[pipeCodeControlIndex].get('pipeSpecs') as UntypedFormArray;
            const versionForm = pipeSpecFromArray.controls[this.selectedTabIndex].get('versions') as UntypedFormArray;
            // if(versionForm.controls.length == 0){

            // } else {
            const targetVersionForm = versionForm.controls[versionForm.controls.length - 1];
            // }

            /**
                 * case ---- operation
                 * 1 ---> Set-up standard form values
                 * 2 ---> Set-up tightening form values
                 * 3 ---> Set-up Process information form values
                 * 4 ---> Set-up clamp form values

            */

            switch (index) {
                case 1: // * standard flange input
                    targetVersionForm.get('minimumPipeSizeId').setValue(res?.minPipeSize);
                    targetVersionForm.get('maximumPipeSizeId').setValue(res?.maxPipeSize);
                    targetVersionForm.get('pipeSizeType').setValue(this.selectedPipeCode.pipeSizeType);

                    targetVersionForm.get('boltType').setValue(res?.boltType);

                    // targetVersionForm.get('jointConfiguration').setValue(res.standard);
                    targetVersionForm.get('tighteningSpecification').setValue(res?.tighteningSpecification);
                    targetVersionForm.get('boltMaterialId').setValue(res?.boltMaterial);
                    // targetVersionForm.get('boltMaterialAliasId').setValue(res.standard);
                    targetVersionForm.get('flangeMaterialId').setValue(res?.flangeMaterial);
                    targetVersionForm.get('flangeFacingTypeId').setValue(res?.flangeFacingType);
                    targetVersionForm.get('flangeTypeId').setValue(res?.flangeType);
                    targetVersionForm.get('gasketId').setValue(res?.gasket);
                    targetVersionForm.get('pipeScheduleId').setValue(res?.pipeSchedule);
                    targetVersionForm.get('pressureClassId').setValue(res?.pressureClass);
                    targetVersionForm.get('standardId').setValue(res?.standard);

                    const currenVersionCalcType1 =
                        this.selectedPipeCode.pipeSpecs[this.selectedTabIndex].versions[versionForm.controls.length - 1].calculationType;
                    targetVersionForm.get('calculationType').setValue(currenVersionCalcType1);
                    // targetVersionForm.get('washerThickness').setValue(res.standard); // ! ANDREW need to checked
                    // pipeSpecFromArray.controls[this.selectedTabIndex].markAsDirty();
                    // pipeSpecFromArray.controls[this.selectedTabIndex].markAsTouched();
                    // targetVersionForm.markAsDirty();
                    // targetVersionForm.markAsTouched();

                    // * updating local properties
                    if (res) {
                        this.selectedPipeCode.pipeSpecs[this.selectedTabIndex].versions[versionForm.controls.length - 1].recordId.standardId = res?.standard;
                        this.selectedPipeCode.pipeSpecs[this.selectedTabIndex].versions[versionForm.controls.length - 1].minimumPipeSizeId = res?.minPipeSize;
                        this.selectedPipeCode.pipeSpecs[this.selectedTabIndex].versions[versionForm.controls.length - 1].maximumPipeSizeId = res?.maxPipeSize;
                        this.selectedPipeCode.pipeSpecs[this.selectedTabIndex].versions[versionForm.controls.length - 1].pipeSizeType =
                            this.selectedPipeCode.pipeSizeType != null && this.selectedPipeCode.pipeSizeType != undefined
                                ? this.selectedPipeCode.pipeSizeType
                                : res.pipeSizeType;
                        this.selectedPipeCode.pipeSpecs[this.selectedTabIndex].versions[versionForm.controls.length - 1].others.boltType = res?.boltType;
                        this.selectedPipeCode.pipeSpecs[this.selectedTabIndex].versions[versionForm.controls.length - 1].recordId.flangeFacingTypeId =
                            res?.flangeFacingType;
                        this.selectedPipeCode.pipeSpecs[this.selectedTabIndex].versions[versionForm.controls.length - 1].others.tighteningSpecification =
                            res?.tighteningSpecification;
                        this.selectedPipeCode.pipeSpecs[this.selectedTabIndex].versions[versionForm.controls.length - 1].recordId.boltMaterialId =
                            res?.boltMaterial;
                        this.selectedPipeCode.pipeSpecs[this.selectedTabIndex].versions[versionForm.controls.length - 1].recordId.flangeMaterialId =
                            res?.flangeMaterial;
                        this.selectedPipeCode.pipeSpecs[this.selectedTabIndex].versions[versionForm.controls.length - 1].recordId.flangeTypeId =
                            res?.flangeType;
                        this.selectedPipeCode.pipeSpecs[this.selectedTabIndex].versions[versionForm.controls.length - 1].recordId.gasketId = res?.gasket;
                        this.selectedPipeCode.pipeSpecs[this.selectedTabIndex].versions[versionForm.controls.length - 1].recordId.pipeScheduleId =
                            res?.pipeSchedule;
                        this.selectedPipeCode.pipeSpecs[this.selectedTabIndex].versions[versionForm.controls.length - 1].recordId.pressureClassId =
                            res?.pressureClass;
                    }
                    break;

                case 2: // * tightening form
                    targetVersionForm.get('tighteningMethod').setValue(res.calcMethod);
                    targetVersionForm.get('breakout').setValue(res?.isBreakout);
                    targetVersionForm.get('lubricantId').setValue(res?.lubricant);
                    targetVersionForm.get('lubricantMode').setValue(res?.lubricantType);
                    if (targetVersionForm.get('tighteningMethod').value == 'Tension') {
                        targetVersionForm.get('percentageCover').setValue((parseFloat(res?.percentageCover) / 100).toFixed(2));
                    }
                    if (targetVersionForm.get('lubricantMode').value == '1') {
                        // targetVersionForm.get('percentageCover').setValue(res?.percentageCover);
                        targetVersionForm.get('kFactor').setValue(res?.lubricantValue);
                    }
                    // pipeSpecFromArray.controls[this.selectedTabIndex].markAsDirty();
                    // pipeSpecFromArray.controls[this.selectedTabIndex].markAsTouched();
                    // TODO Tension method percentage cover pending to bind
                    this.selectedPipeCode.pipeSpecs[this.selectedTabIndex].versions[versionForm.controls.length - 1].others.percentageCover = parseFloat(
                        (res?.percentageCover / 100).toFixed(2)
                    ).toString();

                    this.selectedPipeCode.pipeSpecs[this.selectedTabIndex].versions[versionForm.controls.length - 1].calculationOverrides.kFactor =
                        res?.kFactor;

                    this.selectedPipeCode.pipeSpecs[this.selectedTabIndex].versions[versionForm.controls.length - 1].recordId.lubricantId = res?.lubricant;
                    this.selectedPipeCode.pipeSpecs[this.selectedTabIndex].versions[versionForm.controls.length - 1].others.breakout = res?.isBreakout;
                    this.selectedPipeCode.pipeSpecs[this.selectedTabIndex].versions[versionForm.controls.length - 1].others.lubricantMode = res?.lubricantMode;
                    break;

                case 3:
                    targetVersionForm.get('operatingTemperature').setValue(res.operatingTemp);
                    targetVersionForm.get('operatingPressure').setValue(res?.operatingPressure);
                    targetVersionForm.get('testPressure').setValue(res?.testPressure);

                    this.selectedPipeCode.pipeSpecs[this.selectedTabIndex].versions[versionForm.controls.length - 1].calculationOverrides.operatingTemperature =
                        res?.operatingTemp;
                    this.selectedPipeCode.pipeSpecs[this.selectedTabIndex].versions[versionForm.controls.length - 1].calculationOverrides.operatingPressure =
                        res?.operatingPressure;
                    this.selectedPipeCode.pipeSpecs[this.selectedTabIndex].versions[versionForm.controls.length - 1].calculationOverrides.testPressure =
                        res?.testPressure;
                    break;
                //for clamp form
                case 4:
                    targetVersionForm.get('manufacturerId').setValue(res?.clampManufacturer);
                    // targetVersionForm.get('boltMaterialId').setValue(res?.boltMaterial);
                    targetVersionForm.get('misalignmentFactor').setValue(res?.misalignmentFactor);
                    targetVersionForm.get('clampMaterialId').setValue(res?.clampMaterial);
                    targetVersionForm.get('hubMaterialId').setValue(res?.hubMaterial);
                    targetVersionForm.get('sealRingMaterialId').setValue(res?.sealRingMaterial);

                    targetVersionForm.get('minimumPipeSizeId').setValue(res?.minPipeSize);
                    targetVersionForm.get('maximumPipeSizeId').setValue(res?.maxPipeSize);
                    targetVersionForm.get('pipeSizeType').setValue(this.selectedPipeCode.pipeSizeType);

                    targetVersionForm.get('boltType').setValue(res?.boltType);
                    targetVersionForm.get('boltMaterialId').setValue(res?.boltMaterial);
                    targetVersionForm.get('pipeScheduleId').setValue(res?.pipeSchedule);

                    const currenVersionCalcType =
                        this.selectedPipeCode.pipeSpecs[this.selectedTabIndex].versions[versionForm.controls.length - 1].calculationType;
                    targetVersionForm.get('calculationType').setValue(currenVersionCalcType);

                    if (res) {
                        this.selectedPipeCode.pipeSpecs[this.selectedTabIndex].versions[versionForm.controls.length - 1].recordId.manufacturerId =
                            res?.clampManufacturer;
                        this.selectedPipeCode.pipeSpecs[this.selectedTabIndex].versions[versionForm.controls.length - 1].others.misalignmentFactor =
                            res?.misalignmentFactor;
                        this.selectedPipeCode.pipeSpecs[this.selectedTabIndex].versions[versionForm.controls.length - 1].recordId.boltMaterialId =
                            res?.boltMaterial;
                        this.selectedPipeCode.pipeSpecs[this.selectedTabIndex].versions[versionForm.controls.length - 1].recordId.clampMaterialId =
                            res?.clampMaterial;
                        this.selectedPipeCode.pipeSpecs[this.selectedTabIndex].versions[versionForm.controls.length - 1].recordId.hubMaterialId =
                            res?.hubMaterial;
                        this.selectedPipeCode.pipeSpecs[this.selectedTabIndex].versions[versionForm.controls.length - 1].recordId.sealRingMaterialId =
                            res?.sealRingMaterial;
                        this.selectedPipeCode.pipeSpecs[this.selectedTabIndex].versions[versionForm.controls.length - 1].minimumPipeSizeId = res?.minPipeSize;
                        this.selectedPipeCode.pipeSpecs[this.selectedTabIndex].versions[versionForm.controls.length - 1].maximumPipeSizeId = res?.maxPipeSize;
                        this.selectedPipeCode.pipeSpecs[this.selectedTabIndex].versions[versionForm.controls.length - 1].pipeSizeType =
                            this.selectedPipeCode.pipeSizeType != null && this.selectedPipeCode.pipeSizeType != undefined
                                ? this.selectedPipeCode.pipeSizeType
                                : res.pipeSizeType;
                        this.selectedPipeCode.pipeSpecs[this.selectedTabIndex].versions[versionForm.controls.length - 1].others.boltType = res?.boltType;
                    }

                    break;
            }
        }
    }

    // mat tab change event handler
    handleTabChangeEvent(event): void {
        this.selectedPipeSpec = this.pipeSpecs?.pipeSpecs[this.selectedTabIndex];
    }

    editpipeSpecCombination(pipespec, j) {
        let dialogRef = this.modelService.open(AddCombinationComponent, {
            backdrop: 'static',
        });
        dialogRef.componentInstance.selectedPipeCode = this.selectedPipeCode;
        dialogRef.componentInstance.tittle = 'Edit Combination Name';
        dialogRef.componentInstance.pipeSpecCombination = pipespec;
        dialogRef.componentInstance.mode = 'Edit';
        dialogRef.result
            .then((result: any) => {
                if (result) {
                    if (this.selectedPipeCode.pipeSpecs[j]) {
                        if (result.CombinationName) {
                            this.selectedPipeCode.pipeSpecs[j].name = result.CombinationName;
                            this.cd.detectChanges();
                            let updateObj = new UpdatePipeCodeSpecification();

                            updateObj.pipeSpecs = [];
                            updateObj.name = this.selectedPipeCode.name;
                            updateObj.pipeCodeId = this.selectedPipeCode.pipeCodeId;
                            updateObj.description = this.selectedPipeCode.description;
                            updateObj.pipeSizeType = this.selectedPipeCode.pipeSizeType;

                            const updateSpec = new UpdatePipespec();
                            updateSpec.pipeSpecId = pipespec.pipeSpecId;
                            updateSpec.name = result.CombinationName;
                            // updateSpec.versions = pipespec.versions;
                            updateObj.pipeSpecs.push(updateSpec);

                            this.putapicall([updateObj], 'Pipe Spec Combination is updated Successfully!');
                        }
                    }
                }
            })
            .catch((err) => {
                console.warn(err);
            });
    }

    deletePipeCode(pipe, index: number, i): void {
        let dialogref = this.modelService.open(DeleteDialogComponent, {
            size: 'md',
        });
        let message =
            index == 1
                ? 'Deleting this Pipe Spec Code unlinks all tagged items associated. User Should manually recalculate the tagged items again, if needed!'
                : 'Deleting this Pipe Spec Combination unlinks all tagged items associated. User Should manually recalculate the tagged items again, if needed!';
        dialogref.componentInstance.modalMessage = message;
        dialogref.result
            .then(async (res) => {
                if (res == true) {
                    let formArray = this.idmsFormGroup.get('pipeCodes') as UntypedFormArray;

                    let deletePipeCode = new UpdatePipeCodeSpecification();
                    if (index == 1) {
                        deletePipeCode.name = pipe.name;
                        deletePipeCode.pipeCodeId = pipe.pipeCodeId;
                        deletePipeCode.description = pipe.description;
                        deletePipeCode.pipeSizeType = pipe.pipeSizeType;
                        deletePipeCode.active = false;
                        const deleteItemindex = this.pipeCodes.findIndex((x) => x.name == pipe.name);
                        this.pipeSpecs = null;
                        this.configure = false;
                        this.pipeCodes.splice(deleteItemindex, 1);

                        if (deletePipeCode.pipeCodeId) {
                            try {
                                let res = await this.idmapiService
                                    .PutpipeSpecByInstanceId([deletePipeCode], localStorage.getItem('currentInstanceId'))
                                    .toPromise();

                                if (res.success == true) {
                                    formArray.removeAt(i);
                                    this.selectedPipeCode = null;
                                    this.selectedPipeSpec = null;
                                    this.cd.detectChanges();
                                    this.toastrService.successToast('Pipe Spec has been deleted successfully');
                                } else {
                                    this.user_utility.errorModelPopup(res.message);
                                }
                                this.ngxUiLoaderService.stop();
                            } catch (e) {}
                            this.ngxUiLoaderService.stop();
                        } else {
                            formArray.removeAt(i);

                            this.selectedPipeCode = null;
                            this.selectedPipeSpec = null;
                            this.cd.detectChanges();
                            this.toastrService.successToast('Pipe Spec has been deleted successfully');
                        }
                    } else if (index == 2) {
                        deletePipeCode.pipeSpecs = [];
                        deletePipeCode.name = this.selectedPipeCode.name;
                        deletePipeCode.pipeCodeId = this.selectedPipeCode.pipeCodeId;
                        deletePipeCode.description = this.selectedPipeCode.description;
                        deletePipeCode.pipeSizeType = this.selectedPipeCode.pipeSizeType;

                        const deletePipeSpec = new UpdatePipespec();
                        deletePipeSpec.pipeSpecId = pipe.pipeSpecId;
                        deletePipeSpec.active = false;
                        deletePipeCode.pipeSpecs.push(deletePipeSpec);

                        const deleteItemindex = this.selectedPipeCode.pipeSpecs.findIndex((x) => x.pipeSpecId == pipe.pipeSpecId);
                        this.selectedPipeCode.pipeSpecs.splice(deleteItemindex, 1);

                        if (this.selectedPipeCode.pipeSpecs.length) {
                            this.selectedPipeSpec = this.selectedPipeCode.pipeSpecs[this.selectedPipeCode.pipeSpecs.length - 1];
                        } else {
                            this.selectedPipeSpec = null;
                        }

                        if (!this.selectedPipeCode.pipeSpecs.length) {
                            this.configure = false;
                        }
                        if (deletePipeCode.pipeCodeId && deletePipeCode.pipeSpecs[0].pipeSpecId) {
                            //Api call for deleting pipe Specs
                            this.putapicall([deletePipeCode], 'Pipe Spec Combination has been deleted successfully');
                        } else {
                            let respIndex = this.pipeCodes.findIndex((x) => x.pipeCodeId == this.pipeSpecs.pipeCodeId);

                            let FormGroup = formArray.controls[respIndex] as FormGroup;

                            let resultgroup = FormGroup.controls['pipeSpecs'] as FormArray;
                            resultgroup.removeAt(i);

                            this.toastrService.successToast('Pipe Spec Combination has been deleted successfully');
                        }
                    }
                }
            })
            .catch((err) => {
                console.warn(err);
            });
    }

    // genrate api payload
    generateApiPayload() {
        let pipeCodePayload = [];
        const pipeCodeFormArray = this.idmsFormGroup.get('pipeCodes') as UntypedFormArray;

        pipeCodeFormArray.controls.forEach((mainForm) => {
            const newPipeCode = new AddPipeCodes();
            newPipeCode.pipeSpecs = [];
            if (mainForm.dirty) {
                if (mainForm.get('name').dirty || mainForm.get('description').dirty) {
                    newPipeCode.pipeCodeId = mainForm.value.pipeCodeId;
                    newPipeCode.name = mainForm.value.name;
                    newPipeCode.description = mainForm.value.description;
                    newPipeCode.pipeSizeType = mainForm?.value?.pipeSizeType;
                    delete newPipeCode.pipeSpecs;

                    pipeCodePayload.push(newPipeCode);
                }
                newPipeCode.pipeSpecs = [];
                const pipeSpecFormArray = mainForm.get('pipeSpecs') as UntypedFormArray;

                newPipeCode.name = mainForm.value.name;
                newPipeCode.description = mainForm.value.description;
                newPipeCode.pipeSizeType = mainForm?.value?.pipeSizeType;
                if (mainForm.value.pipeCodeId) {
                    newPipeCode.pipeCodeId = mainForm.value.pipeCodeId;
                }

                pipeSpecFormArray.controls.forEach((pipeSpecForm) => {
                    if (pipeSpecForm.dirty) {
                        const newPipeSpec = new AddPipeSpec();
                        newPipeSpec.name = pipeSpecForm.value.name;
                        newPipeSpec.description = pipeSpecForm.value.description;
                        newPipeSpec.versions = [];
                        if (pipeSpecForm.value.pipeSpecId) {
                            newPipeSpec.pipeSpecId = pipeSpecForm.value.pipeSpecId;
                        }

                        // pipeCodePayload.push()
                        const versionFormArray = pipeSpecForm.get('versions') as UntypedFormArray;
                        versionFormArray.controls.forEach((versionForm) => {
                            let newVersion = new AddPipeSpecVersion();
                            if (versionForm.dirty) {
                                newVersion = versionForm.value;
                                newPipeSpec.versions.push(newVersion);

                                // let newPipeSpecs=Array.from(new Set(newPipeSpec))
                                newPipeCode.pipeSpecs.push(newPipeSpec);
                                newPipeCode.pipeSpecs = Array.from(new Set(newPipeCode.pipeSpecs));
                                pipeCodePayload.push(newPipeCode);
                            }
                        });
                    }
                });
            }
        });

        return Array.from(new Set(pipeCodePayload));
    }

    async savePipeSpecs() {
        let payload = this.generateApiPayload();
        await this.putapicall(payload, 'Pipe Spec Code & Combinations updated successfully');
    }

    async putapicall(payload, Message) {
        try {
            let instanceId = localStorage.getItem('currentInstanceId');
            this.ngxUiLoaderService.start();
            let res = await this.idmapiService.PutpipeSpecByInstanceId(payload, instanceId).toPromise();

            if (res.success == true) {
                let formArray = this.idmsFormGroup.get('pipeCodes') as UntypedFormArray;

                this.idmsFormGroup.get('pipeCodes').markAsPristine();
                formArray.clear();
                let pipeSpecName = '';
                let payloadRow = payload.find((m) => !m.pipeCodeId);
                if (payloadRow) {
                    pipeSpecName = payloadRow?.name;
                }
                await this.getpipeSpec(pipeSpecName);
                if (this.selectedPipeCode) {
                    this.pipeSpecs = this.pipeCodes.find((x) => x.pipeCodeId == this.selectedPipeCode.pipeCodeId);
                    this.selectedPipeCode = this.pipeCodes.find((x) => x.pipeCodeId == this.selectedPipeCode.pipeCodeId);
                    // this.clickActive(this.selectedPipeCode);
                    this.configure = true;
                } else {
                    this.configure = false;
                }
                // this.pipeSpecs = this.pipeCodes.find((x) => x.name == this.selectedPipeCode.name);
                // this.selectedPipeCode = this.pipeCodes.find((x) => x.name == this.selectedPipeCode.name);
                this.toastrService.successToast(Message, 'Success');
                this.globalEmittersService.refreshpipespec.next(true);
                // this.configure = false;

                this.ngxUiLoaderService.stop();
            } else {
                this.ngxUiLoaderService.stop();
                this.user_utility.errorModelPopup(res.message);
            }
        } catch (err) {
            this.ngxUiLoaderService.stop();
            //this.user_utility.errorModelPopup('Something went wrong. Please try again.');
        }
    }

    copyClick(event): void {
        if (event == true) {
            this.addNewVersions();
        }
    }

    deleteClick(event): void {
        if (event == true) {
            try {
                const deleteItemindex = this.selectedPipeSpec.versions.findIndex((x) => !x.pipeSpecVersionId);
                this.selectedPipeSpec.versions.splice(deleteItemindex, 1);
                // this.clickActive(this.selectedPipeCode);
                // Pipe spec form group
                let pipeCodeFormArray = this.idmsFormGroup.get('pipeCodes') as UntypedFormArray;
                this.pipeCodes.forEach((pipeCode, index) => {
                    // Pipecode main form group
                    //   pipeCodeFormArray.push(mainFormGroup(pipeCode));
                    const pipeSpecArray = pipeCodeFormArray.controls[index].get('pipeSpecs') as UntypedFormArray;
                    const versionFormGroup = (version: pipeSpecVersion) => {
                        if (version.calculationType == 0) {
                            return this.formControlHandler(1, version, null, null);
                        } else if (version.calculationType == 2) {
                            return this.formControlHandler(7, version, null, null);
                        }
                    };
                    // Pipe spec form group
                    if (pipeCode?.pipeSpecs?.length) {
                        pipeCode.pipeSpecs.forEach((pipeSpec, pos) => {
                            //   pipeSpecArray.push(pipeSpecFormGroup(pipeSpec));
                            const versionFormArray = pipeSpecArray.controls[pos].get('versions') as UntypedFormArray;
                            versionFormArray.clear();
                            if (pipeSpec.versions?.length) {
                                pipeSpec.versions.forEach((version) => {
                                    versionFormArray.push(versionFormGroup(version));
                                });
                            }
                        });
                    }
                });
                this.cd.detectChanges();
                this.idmsFormGroup.get('pipeCodes').markAsPristine();
                this.toastrService.successToast('Version deleted successfully.', 'Success');
            } catch (e) {
                this.toastrService.errorToast('Version Deletion Failed', 'Error');
            }
        }
    }

    editpipeCode(event: any, type: number, index): void {
        let pipeCodeFormArray = this.idmsFormGroup.get('pipeCodes') as UntypedFormArray;
        if (type == 1) {
            this.selectedPipeCode.name = pipeCodeFormArray.controls[index].value.name;
            this.pipeCodeNameList = pipeCodeFormArray.controls
                .filter((x) => x.value.name != pipeCodeFormArray.controls[index].value.name)
                .map((x) => x.value.name);

            pipeCodeFormArray.controls[index].get('name').addValidators(UniqueNameValidation(this.pipeCodeNameList));
        } else if (type == 2) {
            this.selectedPipeCode.description = pipeCodeFormArray.controls[index].value.description;
        }
    }

    consoleForm() {}

    recalculateCodes(type: string) {
        let dialogRef = this.modelService.open(SuccessDialogComponent, {
            size: 'md',
            keyboard: false,
            backdrop: 'static',
        });

        dialogRef.componentInstance.message =
            type == 'pipecodes'
                ? 'Please click "Recalculate" to perform a batch calculation of all joints created based on the selected Pipe Code(s).'
                : 'Please click "Recalculate" to perform a batch calculation of all joints created based on the Pipe Spec combination.';
        dialogRef.componentInstance.buttonText = 'Recalculate';

        dialogRef.result.then(
            (res) => {
                if (res) {
                    let pipeCodeFormArray = this.idmsFormGroup.get('pipeCodes') as UntypedFormArray;

                    let payload;

                    switch (type) {
                        case 'pipecodes':
                            payload = pipeCodeFormArray.controls.filter((control) => control.value.isCheck).map((control) => control?.value?.pipeCodeId);
                            break;
                        case 'pipespecs':
                            payload = [this.selectedPipeSpec.pipeSpecId];
                            break;
                    }
                    this.uploadsPipeCodesApiCall(type, payload);
                }
            },
            (err) => {}
        );
    }

    async uploadsPipeCodesApiCall(type: string, payload: string[]) {
        try {
            if (payload.length) {
                let res = await this.uploadApiService.reCalculatePipeCodes(type, payload).toPromise();

                if (res.success) {
                    this.toastrService.successToast(
                        "Recalculation request submitted successfully. To check recalculation status, please visit the 'Batch Calculation Status' tab.",
                        'Success'
                    );
                    this.globalEmittersService.pipeCodeReCalculate.next(true);
                } else {
                    this.user_utility.errorModelPopup(res.message);
                }
            }
        } catch (e) {}
    }

    disableRecalculate() {
        let pipeCodeFormArray = this.idmsFormGroup.get('pipeCodes') as UntypedFormArray;

        return pipeCodeFormArray.controls.every((x) => !x.value.isCheck);
    }

    disableVersrion() {
        return !this.selectedPipeSpec?.versions.every((x) => x.pipeSpecVersionId);
    }

    disableCombination(): boolean {
        if (
            (this.selectedPipeCode?.pipeSpecs?.length && !this.selectedPipeCode?.pipeSpecs.every((x) => x?.pipeSpecId)) ||
            (this.selectedPipeSpec?.versions && !this.selectedPipeSpec?.versions.every((x) => x?.pipeSpecVersionId))
        ) {
            return true;
        }
        return false;
    }

    disableSpec(): boolean {
        if (
            (this.selectedPipeSpec && !this.selectedPipeSpec.versions.every((x) => x?.pipeSpecVersionId)) ||
            (this.selectedPipeCode?.pipeSpecs?.length && !this.selectedPipeCode?.pipeSpecs.every((x) => x?.pipeSpecId)) ||
            !this.pipeCodes.every((x) => x.pipeCodeId)
        ) {
            return true;
        }
        return false;
    }

    editPipeSpec(pipe) {
        this.clickActive(pipe);
        let dialogRef = this.modelService.open(AddPipeSpecComponent);

        dialogRef.componentInstance.tittle = 'Edit Pipe Spec';
        dialogRef.componentInstance.pipeSpec = pipe;
        dialogRef.componentInstance.mode = 'Edit';

        dialogRef.result.then((result) => {
            if (result) {
                let updateObj = new UpdatePipeCodeSpecification();
                updateObj.name = pipe.name;
                updateObj.pipeCodeId = pipe.pipeCodeId;
                updateObj.description = result.discription;
                updateObj.pipeSizeType = pipe.pipeSizeType;
                // updateObj.pipeSpecs = pipe.pipeSpecs;
                if (this.selectedPipeCode.name !== result.name) {
                    let dialog = this.modelService.open(WarningConfirmationDialogComponent, {
                        size: 'lg',
                    });
                    dialog.componentInstance.modalMessage =
                        "Warning - Editing the Pipe Spec Name will break existing links to Lines and Joints, potentially losing auto-calculation feature. Proceed with caution. Click 'YES' to continue.";

                    dialog.result.then((resp) => {
                        if (resp) {
                            updateObj.name = result.name;
                            this.putapicall([updateObj], 'Pipespec Updated Succfully!');
                        }
                    });
                } else {
                    this.putapicall([updateObj], 'Pipespec Updated Succfully!');
                }
            }
        });
    }

    ngOnDestroy(): void {
        this.destory$.next(null);
        this.destory$.complete();
    }
}
